import { createSlice } from "@reduxjs/toolkit";
import { addActivityHistoryItemReducer } from "./add/add-history-item/reducer";
import { addActivityHistoryItemsReducer } from "./add/add-history-items/reducer";
import { addBusyHistoryItemReducer, removeBusyHistoryItemReducer } from "./add/handle-busy/reducers";
import { addErrorHistoryItemReducer, removeErrorHistoryItemReducer } from "./add/handle-error/reducers";
import { clearActivityHistoryCollectionsReducer } from "./clear/reducer";
import { IActivityHistoryItemCollection, IBusyHistoryItem, IErrorHistoryItem } from "./domain/model";
import { removeActivityHistoryItemReducer } from "./remove/reducer";
import { updateActivityHistoryItemReducer } from "./update/reducer";

export const activityHistoryCollectionsSlice = createSlice({
  name: "activity-history-collections",
  initialState: {
    busy: [] as IBusyHistoryItem[],
    error: [] as IErrorHistoryItem[],
    collections: {} as Record<string, IActivityHistoryItemCollection>,
  },
  reducers: {
    addBusyHistoryItem: addBusyHistoryItemReducer,
    removeBusyHistoryItem: removeBusyHistoryItemReducer,
    addActivityHistoryItem: addActivityHistoryItemReducer,
    updateActivityHistoryItem: updateActivityHistoryItemReducer,
    addActivityHistoryItems: addActivityHistoryItemsReducer,
    clearActivityHistoryCollections: clearActivityHistoryCollectionsReducer,
    addErrorHistoryItem: addErrorHistoryItemReducer,
    removeErrorHistoryItem: removeErrorHistoryItemReducer,
    removeActivityHistoryItem: removeActivityHistoryItemReducer,
  },
});
